<template>
  <span v-if="!renderContent.isStatusLabel">{{ renderContent.label }}</span>
  <el-tag
    v-else
    disable-transitions
    style="border: 0"
    :type="renderContent?.type || renderContent?.listClass"
  >
    <span
      style="
        display: inline-block;
        text-align: center;
        vertical-align: middle !important;
      "
    >
      {{ renderContent.label }}</span
    ></el-tag
  >
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "table-select",
  props: {
    row: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  computed: {
    renderContent() {
      return this.findLabel();
    },
  },
  methods: {
    findLabelForValue(
      value: string | number,
      configs: IOptions[]
    ): {
      label: string;
      type: string;
    } {
      const result = configs.find((each) => {
        return each.value + "" === value + "";
      });
      const label =
        result && result.label === "ALL" ? "" : result && result.label;
        
      return {
        label: label || "--",
        type: result?.type || result?.listClass || "info",
      };
    },
    findLabel(): {
      label: string;
      isStatusLabel: boolean;
      type: string;
    } {
      let label = "--";
      const value = this.row[this.config.prop];
      const config = this.config.options;
      let type = "info";
      // 只要枚举里面有type就是状态标签
      const isStatusLabel = this.config.options.some(
        (e: { type: any }) => e.type || e.listClass
      );
      // const dictName = this.config.dictName;
      if (value == null || value == undefined) {
        return { label, isStatusLabel, type };
      }
      if (("" + value).includes(",")) {
        return value
          ?.split(",")
          ?.map((e: string | number) =>
            this.$t(this.findLabelForValue(e, config)?.label)
          )
          ?.filter((e: string) => e !== "")
          ?.join(",");
      }
      if (config) {
        label = this.$t(this.findLabelForValue(value, config)?.label);
        type =
          this.findLabelForValue(value, config).type ||
          this.findLabelForValue(value, config).listClass;
      }

      return { label, isStatusLabel, type };
    },
  },
});
</script>
